'use client'

import textActionM from '@fukku/styles/texts/textActionM.module.css'
import { cx } from 'classix'
import { IconKeyboardNext } from 'icons/components/IconKeyboardNext'
import styles from './CountryLanguageButton.module.css'

type CountryLanguageButtonProps = {
	readonly onClick: () => void
	readonly countryName: string
	readonly isMultiLanguage: boolean
	readonly languageName: string
}

export const CountryLanguageButton = ({
	onClick,
	countryName,
	isMultiLanguage,
	languageName,
}: CountryLanguageButtonProps) => (
	<button
		type='button'
		className={cx(styles.button, textActionM.className)}
		onClick={onClick}
		data-testid='changeButton'
	>
		<span className={styles.buttonContent}>
			<span className={styles.countryTextMobile}>
				<span className={styles.countryText}>
					{countryName}
					{isMultiLanguage && <span aria-hidden>·</span>}
				</span>
				{isMultiLanguage && (
					<span className={styles.countryText}>{languageName}</span>
				)}
			</span>
			<IconKeyboardNext className={styles.icon} rotateRtl />
		</span>
	</button>
)
